import React from "react";
import PropTypes from "prop-types";
import css from "./PhotoCredit.module.scss";
import cn from "classnames"

const PhotoCredit = ({ label, text, className }) => {
    return (
        <div className={cn(css.photographer, {[className]: className})}>
            {label && (
                <span>{label}:{' '}</span>
            )}
            {text}
        </div>
    )
};

PhotoCredit.propTypes = {
    label: PropTypes.string,
    text: PropTypes.string,
    className: PropTypes.string
}

export default PhotoCredit;


// WEBPACK FOOTER //
// ./src/components/PhotoCredit/PhotoCredit.jsx